import { render, staticRenderFns } from "./related-est.vue?vue&type=template&id=39b2484d&scoped=true"
import script from "./related-est.vue?vue&type=script&lang=js"
export * from "./related-est.vue?vue&type=script&lang=js"
import style0 from "./related-est.vue?vue&type=style&index=0&id=39b2484d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b2484d",
  null
  
)

export default component.exports